<template>
  <div class="content">
    <!-- 新增按钮 -->
    <el-form :inline="true" class="demo-form-inline" size="small">
      <el-form-item>
        <el-button type="primary" @click="handleAdd">新增</el-button>
      </el-form-item>
    </el-form>
    <!-- 商品表格 -->
    <el-table
      :data="beforArr"
      style="width: 100%;overflow-y: scroll;"
      height="calc(100vh - 220px)"
      v-loading="loading"
    >
      <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
      <el-table-column label="视频ID" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      
      <el-table-column label="视频状态" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.status==0?'正常':'下架' }}</span>
        </template>
      </el-table-column>

      <el-table-column label="视频标题" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column label="视频链接" align="center" width="420">
        <template slot-scope="scope">
          <div v-if="scope.row.url">
            <div style="margin-bottom: 8px;">{{ scope.row.url }}</div>
            <el-button
              size="mini"
              type="primary"
              icon="el-icon-video-play"
              @click="playVideo(scope.row.url)"
            >播放视频</el-button>
          </div>
          <span v-else>暂无</span>
        </template>
      </el-table-column>
      <el-table-column label="排序(从大到小排序)" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.sort }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" align="center">
        <template slot-scope="scope">
          <el-button size="mini" @click="ejectupdateGoods(scope.row)">修改</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="deleteAdmin(scope.row)"
            :disabled="$store.state.supUser.roleId == 1"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 新增表单 -->
    <el-dialog :title="inputTitle" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <el-form :model="form">
        <el-form-item label="视频状态: ">
          <el-select v-model="form.status" placeholder="请选择" clearable>
            <div v-for="item in statusList" :key="item.id">
              <el-option :label="item.name" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="视频标题" required>
          <el-input v-model="form.title" auto-complete="off" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="视频链接" required>
          <el-input
            v-model="form.url"
            auto-complete="off"
            clearable
            placeholder="请输入"
            type="textarea"
            :rows="5"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model="form.sort" auto-complete="off" placeholder="默认为0"></el-input>
        </el-form-item>
        <!-- 图片预览 -->
        <el-form-item label="封面预览">
          <div class="demo-image__preview">
            <el-image
              style="width: 100px; height: 100px"
              :src="this.form.head_img"
              :preview-src-list="[this.form.head_img]"
            ></el-image>
          </div>
        </el-form-item>
        <el-upload
          class="upload-demo"
          :action="action"
          :multiple="false"
          :on-success="handleSuccess_cover"
          :file-list="fileList"
          list-type="picture"
          name="formData"
          :limit="1"
        >
          <el-button size="small" type="primary">点击上传封面(1张),会覆盖之前的</el-button>
          <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，750px X 300px</div>
        </el-upload>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumbmitBtn">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 视频播放弹窗组件 -->
    <VideoPlayer
      v-model="videoPlayVisible"
      :videoUrl="playVideoUrl"
      @close="closeVideo"
    />
  </div>
</template>

<script>
import {
  selectVideoConfig,
  addVideoConfig,
  updateVideoConfig,
  deleteVideoConfig
} from "@/services/video/videoConfig.js";
import { IP } from "@/services/index.js";
import VideoPlayer from "@/components/VideoPlayer/index.vue";

export default {
  components: {
    VideoPlayer
  },
  data() {
    return {
      beforArr: [],
      inputTitle: "新增",
      cover: "",
      fileList: [], //上传列表
      action: IP + "/uploadFile/add",
      loading: true,
      name: "",
      pageCount: "",
      pageSize: 8,
      adminArr: [
        { name: "最高权限", id: "0" },
        { name: "普通子账号权限", id: "1" }
      ],
      form: {},
      dialogFormVisible: false,
      statusList: [
        { id: 0, name: "正常" },
        { id: 1, name: "下架" }
      ],
      // 视频播放相关
      videoPlayVisible: false,
      playVideoUrl: ""
    };
  },
  created() {

    this.selectData();
  },
  methods: {
    // 查询
    selectData() {
      selectVideoConfig().then(resp => {

        this.loading = false;
        this.beforArr = resp.data;
      });
    },
    // 新增按钮
    handleAdd() {
      this.inputTitle = "新增";
      this.dialogFormVisible = true;
      this.form = {};
      this.fileList = [];
    },
    ejectupdateGoods(row) {
      this.dialogFormVisible = true;
      this.inputTitle = "修改";
      this.form = JSON.parse(JSON.stringify(row));
      this.fileList = [];
    },
    /* 上传图片 */
    handleSuccess_cover(e) {
      this.form.head_img = e.data;
      // console.log(this.form);
      this.fileList = []; //清空列表
    },
    // 表单提交按钮
    sumbmitBtn() {
      if (this.form.sort == "" || this.form.sort == null) {
        this.form.sort = 0;
      }
      if (!this.form.url || !this.form.title) {
        this.$message({
          type: "info",
          message: "请输入标题和视频链接"
        });
        return;
      }
      this.form.status = this.form.status == 1 ? 1 : 0;
      console.log(this.form);
      if (this.inputTitle == "新增") {
        console.log(this.form);
        addVideoConfig(this.form).then(res => {
          if (res.code == 200) {
            this.dialogFormVisible = false;
            this.$message({
              type: "success",
              message: "新增成功!"
            });
            this.selectData();
          } else {
            this.$message({
              type: "info",
              message: "操作失败，请联系管理员"
            });
          }
        });
        return;
      }

      updateVideoConfig(this.form).then(res => {
        if (res.code == 200) {
          this.dialogFormVisible = false;
          this.$message({
            type: "success",
            message: "修改成功!"
          });
          this.selectData();
        } else {
          this.$message({
            type: "info",
            message: "操作失败，请联系管理员"
          });
        }
      });
    },
    // 删除
    deleteAdmin(row) {
      this.$confirm("此操作将永久删除该账号, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          console.log(row.id);
          deleteVideoConfig(row.id).then(resp => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.selectData();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },

    // 视频播放
    playVideo(videoUrl) {
      if (!videoUrl) {
        this.$message.warning("视频地址为空");
        return;
      }
      this.playVideoUrl = videoUrl;
      this.videoPlayVisible = true;
    },

    // 关闭视频播放
    closeVideo() {
      this.videoPlayVisible = false;
      this.playVideoUrl = "";
    }
  }
};
</script>

<style>
.content {
  margin: 10px auto;
  width: 98%;
}

.el-pagination {
  text-align: center;
  margin: 20px;
}

.userNanme:hover {
  cursor: pointer;
}
</style>
